<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>分享配置</span>
          <el-button v-permisaction="['config:shareConfig:add']" type="primary" size="mini" style="margin-left: 16px;" @click="add()">新增</el-button>
          <CommonExport :import-p="'config:shareConfig:import'" :export-p="'config:shareConfig:export'" :get-table="getTables" :import-method="importShareCfg" :export-method="exportShareCfg" />
          <!--          <el-button v-permisaction="['config:shareConfig:async']" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <syncVersion :in-method="uploadCdn" />
          <!--          <clear-cache-apply />-->
          <sync-data />
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="key"
              label="分享ID"
              width="200px"
              align="center"
            />
            <el-table-column
              prop="name"
              label="名称"
              align="center"
            />
            <el-table-column
              prop="maxTimes"
              label="免费体力分享次数上限"
              width="150"
              align="center"
            />
            <el-table-column
              prop="reward"
              label="奖励"
              align="center"
              :formatter="rewardFormatter"
            />

            <el-table-column
              prop="show"
              label="状态"
              align="center"
              :formatter="statusFormatter"
            />
            <el-table-column
              prop="intervalTime"
              label="冷却时间"
              width="180px"
              align="center"
            />
            <el-table-column
              prop="actImg.DEFAULT"
              label="分享图片ID"
              width="180px"
              align="center"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="200"
            >
              <template v-slot:default="scope">
                <el-button v-permisaction="['config:shareConfig:edit']" type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
                <el-button v-permisaction="['config:shareConfig:del']" type="danger" size="mini" @click="del(scope.row.key)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="750px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="分享ID" prop="key" style="width: 400px;">
            <el-select v-model="formData.key" placeholder="请选择">
              <el-option
                v-for="item in shareCfg"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled "
              />
            </el-select>
          </el-form-item>
          <el-form-item label="分享最大次数" prop="maxTimes" style="width: 400px;">
            <el-input v-model.number="formData.maxTimes" placeholder="分享最大次数" />
          </el-form-item>
          <el-form-item label="冷却时间" prop="intervalTime" style="width: 400px;">
            <el-input v-model.number="formData.intervalTime" placeholder="冷却时间" />
          </el-form-item>
          <el-form-item label="名称" prop="name" style="width: 400px">
            <el-input v-model.trim="formData.name" placeholder="名称" />
          </el-form-item>
          <el-form-item label="奖励体力" prop="reward" style="width: 400px">
            <el-input v-model.number="formData.reward[0].num" placeholder="奖励体力" />
          </el-form-item>

          <!--          <el-form-item label="分享标题" prop="reward">-->
          <!--            <el-input v-model="formData.content.title" placeholder="分享标题" />-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="分享描述" prop="content">-->
          <!--            <el-input v-model="formData.content.desc" placeholder="分享描述" />-->
          <!--          </el-form-item>-->

          <el-form-item label="可用状态" prop="show">
            <el-select v-model.number="formData.show" placeholder="请选择">
              <el-option
                v-for="item in statusType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <!--          <el-form-item label="统计-默认">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.DEFAULT.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.DEFAULT.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.DEFAULT.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-德语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.DE.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.DE.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.DE.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-法语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.FR.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.FR.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.FR.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-英语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.US.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.US.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.US.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-西班牙语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.GB.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.GB.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.GB.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-西班牙语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.ES.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.ES.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.ES.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-泰语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.TH.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.TH.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.TH.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="统计-葡萄牙语">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item label="d" prop="coins">-->
          <!--                <el-input v-model="formData.track.BR.d" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="a" prop="spins">-->
          <!--                <el-input v-model="formData.track.BR.a" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="b" prop="spins">-->
          <!--                <el-input v-model="formData.track.BR.b" style="width: 150px" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->

          <el-form-item label="图片ID" prop="actImg.DEFAULT">
            <el-input v-model.number="formData.actImg.DEFAULT" placeholder="图片ID" />
          </el-form-item>

          <!--          <el-form-item label="图片上传">-->
          <!--            <el-upload-->
          <!--              :class="{hide_box: actImg !== ''}"-->
          <!--              :action="sys_app_logoAction"-->
          <!--              list-type="picture-card"-->
          <!--              :auto-upload="true"-->
          <!--              :limit="1"-->
          <!--              :headers="headers"-->
          <!--              :file-list="fileList"-->
          <!--              :before-upload="beforeAvatarUpload"-->
          <!--              :on-success="(file)=>uploadSuccess(file)"-->
          <!--            >-->
          <!--              <i slot="default" class="el-icon-plus" />-->
          <!--              <div slot="file" slot-scope="{file}">-->
          <!--                <img-->
          <!--                  class="el-upload-list__item-thumbnail"-->
          <!--                  :src="file.url"-->
          <!--                  alt=""-->
          <!--                >-->

          <!--                <span class="el-upload-list__item-actions">-->
          <!--                  <span-->
          <!--                    class="el-upload-list__item-preview"-->
          <!--                    @click="handlePictureCardPreview(file)"-->
          <!--                  >-->
          <!--                    <i class="el-icon-zoom-in" />-->
          <!--                  </span>-->
          <!--                  <span-->
          <!--                    class="el-upload-list__item-delete"-->
          <!--                    @click="v=>handleRemove(file)"-->
          <!--                  >-->
          <!--                    <i class="el-icon-delete" />-->
          <!--                  </span>-->
          <!--                </span>-->
          <!--              </div>-->
          <!--            </el-upload>-->
          <!--          </el-form-item>-->

          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { searchUid } from '@/api/user/user_info'
import {
  delShareCfg,
  exportShareCfg,
  getShareCfg,
  getShareCfgList,
  importShareCfg,
  updateShareCfg,
  uploadCdn
} from '@/api/config/share-cfg'
import { getToken } from '@/utils/auth'
import CommonExport from '@/components/CommonExport/index.vue'
import { importAirship2Cfg } from '@/api/config/airship2'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'ShareConfig',
  components: {
    SyncData,
    SyncVersion,
    CommonExport
  },
  data() {
    return {
      shareCfg: [],
      dialogVisible: false,
      dialogImageUrl: '',
      actImg: '',
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      rewardTypes: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 100
      },
      statusType: [{ label: '禁用', value: 0 }, { label: '启用', value: 1 }],
      userType: [{ label: '所有', value: 0 }, { label: 'fb', value: 1 }, { label: '游客', value: 2 }],
      rewardType: [{ label: '不随机', value: 0 }, { label: '随机', value: 1 }],
      formDataBak: {
        show: 0,
        key: '',
        name: '',
        maxTimes: 0,
        reward: [{ num: 0 }],
        intervalTime: 0,
        content: [],
        shareType: 1,
        lang: ['DEFAULT', 'DE', 'FR', 'US', 'GB', 'ES', 'TH'],
        track: {
          DEFAULT: { a: '', b: '', d: '' },
          DE: { a: '', b: '', d: '' },
          FR: { a: '', b: '', d: '' },
          US: { a: '', b: '', d: '' },
          GB: { a: '', b: '', d: '' },
          TH: { a: '', b: '', d: '' },
          BR: { a: '', b: '', d: '' },
          ES: { a: '', b: '', d: '' }
        },
        actImg: {
          DEFAULT: 0
        }
      },
      formData: {
        show: 0,
        key: '',
        name: '',
        maxTimes: 0,
        reward: [{ num: 0 }],
        intervalTime: 0,
        content: [],
        shareType: 1,
        track: {
          DEFAULT: { a: '', b: '', d: '' },
          DE: { a: '', b: '', d: '' },
          FR: { a: '', b: '', d: '' },
          US: { a: '', b: '', d: '' },
          GB: { a: '', b: '', d: '' },
          TH: { a: '', b: '', d: '' },
          BR: { a: '', b: '', d: '' },
          ES: { a: '', b: '', d: '' }
        },
        actImg: { DEFAULT: 0 }
      },
      users: [],
      rules: {
        key: [
          { required: true, message: '请输入分享KEY', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        intervalTime: [
          { required: true, message: '请输入冷却时间', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getShareCfg()
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    uploadCdn,
    exportShareCfg,
    importShareCfg,
    importAirship2Cfg,
    handleClose(d) {
      this.drawer = false
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          this.rewardTypes = res.data
        }
      })
    },
    edit(row) {
      this.formData = row
      this.drawer = true
    },
    addReward() {
      this.formData.rwd.props.push({ propsId: '', num: 1 })
    },
    delReward(i) {
      this.formData.rwd.props = this.formData.rwd.props.filter((item, index) => {
        return index !== i
      })
    },
    getShareCfg() {
      getShareCfg().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shareCfg.push({ label: res.data[i], value: i, disabled: false })
          }
        }
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          console.log('data', _data)
          if (_data.key === '') {
            this.msgError('分享KEY不能为空')
            return
          }
          if (_data.maxTimes <= 0) {
            this.msgError('分享最大次数不能小于0')
            return
          }

          // if (!_data.content.title) {
          //   this.msgError('分享标题不能为空')
          //   return
          // }
          //
          // if (!_data.content.desc) {
          //   this.msgError('分享描述不能为空')
          //   return
          // }

          if (!_data.actImg.DEFAULT) {
            this.msgError('图片ID不能为空')
            return
          }

          const data = JSON.stringify(this.formData)
          console.log(data)
          updateShareCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTables() {
      this.loading = true
      getShareCfgList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
          this.listenSelectType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data
        })
      } else {
        this.users = []
      }
    },
    add() {
      this.listenSelectType()
      let selectType = ''
      for (const i in this.shareCfg) {
        const val = this.shareCfg[i]
        if (!val.disabled) {
          selectType = val.value
          break
        }
      }

      if (!selectType) {
        this.msgError('无可选类型')
        return
      }

      this.formData = {
        show: 0,
        key: selectType,
        name: '',
        maxTimes: 0,
        reward: [{ num: 0 }],
        intervalTime: 0,
        content: [],
        shareType: 1,
        lang: ['DEFAULT', 'DE', 'FR', 'US', 'GB', 'ES', 'TH'],
        track: {
          DEFAULT: { a: '', b: '', d: '' },
          DE: { a: '', b: '', d: '' },
          FR: { a: '', b: '', d: '' },
          US: { a: '', b: '', d: '' },
          GB: { a: '', b: '', d: '' },
          TH: { a: '', b: '', d: '' },
          BR: { a: '', b: '', d: '' },
          ES: { a: '', b: '', d: '' }
        },
        actImg: { DEFAULT: 0 }
      }
      this.drawer = true
    },
    del(key) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delShareCfg({ name: key }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    statusFormatter(row, col) {
      let text = '禁用'
      if (row.show === 1) {
        text = '启用'
      }
      return text
    },
    userTypeFormatter(row, col) {
      let userTypeText = ''
      for (const i in this.userType) {
        const val = this.userType[i]
        if (val.value === row.status) {
          userTypeText = val.label
          break
        }
      }
      return userTypeText
    },
    randomRewardFormatter(row, col) {
      let randomRewardText = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === row.status) {
          randomRewardText = val.label
          break
        }
      }
      return randomRewardText
    },
    rewardFormatter(row, col) {
      let text = ''
      text += ' 体力 * ' + row.reward[0]['num']

      return text
    },
    userLimitFormatter(row, col) {
      let text = ''
      row.userLimit.forEach(item => {
        text += item + ','
      })

      return text
    },
    handleRemove(file) {
      this.actImg = ''
      this.fileList = []
    },
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     uploadCdn().then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // },
    listenSelectType() {
      for (const k in this.shareCfg) {
        const event = this.shareCfg[k]
        this.shareCfg[k].disabled = false
        for (const i in this.tableData) {
          const val = this.tableData[i]
          if (val.key === event.value) {
            this.shareCfg[k].disabled = true
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.hide_box /deep/ .el-upload--picture-card {
  display: none;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
